import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTableCol = () => {
  return (
    <g>
      <path d="M1.6678 16.0038a1.6437 1.6437 0 0 1-1.096-.4313A1.7177 1.7177 0 0 1 0 14.3057V1.6943A1.6963 1.6963 0 0 1 1.6943 0h12.6114A1.6963 1.6963 0 0 1 16 1.6943v12.6114A1.6963 1.6963 0 0 1 14.3057 16H1.779c-.0369.0027-.0743.0038-.1112.0038zm.0265-14.6149a.302.302 0 0 0-.3054.3054v12.6114a.3361.3361 0 0 0 .115.237.2452.2452 0 0 0 .1769.0717l.0689-.0033h12.556a.302.302 0 0 0 .3054-.3054V1.6943a.302.302 0 0 0-.3054-.3054z" />
      <path d="M3.7224.6668h1.3889v14.6664H3.7224z" />
      <path d="M.23679062 12.69208759l.7378489-1.17619835 4.00974785 2.5153819-.7378489 1.17619835zM.23653838 9.1358777l.73833393-1.17674962 4.01045281 2.51629857-.73833392 1.17674961zM.23652695 5.58003623l.73833392-1.17674961L4.9853137 6.91958518l-.73833392 1.17674961zM.23652376 2.02481365L.97485768.84806404 4.9853105 3.3643626 4.24697658 4.5411122z" />
    </g>
  );
};

export default withIcon(IconTableCol);
